import {
  CalendarStartIcon_default
} from "./chunk-4CTZAQPK.mjs";
export {
  CalendarStartIcon_default as default
};
